import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaUsers, FaUserTie, FaClipboardList, FaClock, FaEye, FaFileAlt, FaCog, FaChartBar, FaBullhorn, FaTachometerAlt, FaGamepad } from 'react-icons/fa';
import styles from './SidebarNav.module.css';

const SidebarNav = ({ 
  activeSection, 
  onSectionChange, 
  counts = {},
  isRegistrationEnabled = false 
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const sections = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: FaTachometerAlt,
      type: 'single'
    },
    {
      id: 'people',
      label: 'People',
      icon: FaUsers,
      type: 'group',
      items: [
        { id: 'all-people', label: 'All People', icon: FaUsers, count: counts.total },
        { id: 'members', label: 'Members', icon: FaUsers, count: counts.members },
        { id: 'staff', label: 'Staff', icon: FaUserTie, count: counts.staff },
        { id: 'applicants', label: 'Applicants', icon: FaClipboardList, count: counts.applicants, badge: counts.pendingApplicants > 0 },
        { id: 'waitlist', label: 'Waitlist', icon: FaClock, count: counts.waitlist },
        { id: 'followers', label: 'Followers', icon: FaEye, count: counts.followers },
      ]
    },
    {
      id: 'enrollment',
      label: 'Enrollment',
      icon: FaFileAlt,
      type: 'group',
      items: [
        { id: 'registration', label: 'Registration Setup', icon: FaCog, badge: !isRegistrationEnabled },
        { id: 'applications', label: 'Applications', icon: FaClipboardList, count: counts.applications },
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: FaCog,
      type: 'group',
      items: [
        { id: 'scorecard', label: 'Scorecard', icon: FaGamepad },
        { id: 'capacity', label: 'Capacity', icon: FaChartBar },
        { id: 'analytics', label: 'Analytics', icon: FaChartBar },
        { id: 'notifications', label: 'Notifications', icon: FaBullhorn },
      ]
    }
  ];

  const renderNavItem = (item, isNested = false) => {
    const isActive = activeSection === item.id;
    const Icon = item.icon;
    
    return (
      <button
        key={item.id}
        className={`${styles.navItem} ${isNested ? styles.nestedItem : ''} ${isActive ? styles.active : ''}`}
        onClick={() => onSectionChange(item.id)}
        title={isCollapsed ? item.label : undefined}
      >
        <span className={styles.navIcon}>
          <Icon />
        </span>
        {!isCollapsed && (
          <>
            <span className={styles.navLabel}>{item.label}</span>
            {item.count !== undefined && (
              <span className={styles.navCount}>{item.count}</span>
            )}
            {item.badge && (
              <span className={styles.navBadge}>!</span>
            )}
          </>
        )}
      </button>
    );
  };

  const renderSection = (section) => {
    if (section.type === 'single') {
      return renderNavItem(section);
    }

    const Icon = section.icon;
    const hasActiveChild = section.items?.some(item => activeSection === item.id);

    return (
      <div key={section.id} className={styles.navGroup}>
        {!isCollapsed && (
          <div className={`${styles.groupHeader} ${hasActiveChild ? styles.groupHeaderActive : ''}`}>
            <Icon className={styles.groupIcon} />
            <span>{section.label}</span>
          </div>
        )}
        <div className={styles.groupItems}>
          {section.items?.map(item => renderNavItem(item, true))}
        </div>
      </div>
    );
  };

  return (
    <aside className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        {!isCollapsed && <h3>Program Management</h3>}
        <button 
          className={styles.collapseButton}
          onClick={() => setIsCollapsed(!isCollapsed)}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </div>

      <nav className={styles.nav}>
        {sections.map(section => renderSection(section))}
      </nav>

      {!isCollapsed && (
        <div className={styles.sidebarFooter}>
          <p className={styles.footerText}>Pro tip: Press <kbd>?</kbd> for shortcuts</p>
        </div>
      )}
    </aside>
  );
};

export default SidebarNav;

